module.exports = __webpack_public_path__ + "img/testimonial-image-03.189141ca.png";